/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
import * as Types from '@/backoffice/types/types.generated';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseBackofficeApi } from '../../base-api';
export type BackofficeUserInfoFragment = { __typename: 'LightUserResponseType', userId: string, firstName: string, lastName: string, email: string, source: Types.UserSourceEnum, isSystemUser?: boolean, termsAndConditions: { __typename: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, acceptedTimestamp?: any, termsAndConditionsVersion?: number, latestTermsAndConditionsVersionAccepted: boolean } };

export type BackofficeTenantFragment = { __typename: 'TenantResponseType', tenantId: string, companyName: string, country?: string, ssoEnabled?: boolean, objectVersion?: number, creationTimestamp?: any, industry?: string, isActive: boolean, groupId?: string, metaData?: any, owner?: { __typename: 'LightUserResponseType', userId: string, firstName: string, lastName: string, email: string, source: Types.UserSourceEnum, isSystemUser?: boolean, termsAndConditions: { __typename: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, acceptedTimestamp?: any, termsAndConditionsVersion?: number, latestTermsAndConditionsVersionAccepted: boolean } } };

export type SuperUserPolicyFragment = { __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string };

export type BaseSuperUserFragment = { __typename: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string };

export type SuperUserForSelectFragment = { __typename: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, email: string, source: Types.UserSourceEnum, groupId?: string, objectVersion?: number, userRoles: { __typename: 'PaginatedSuperUserRoleResponseType', items: Array<{ __typename: 'SuperUserRoleResponseType', isSystemRole: boolean }> } };

export type SuperUserFragment = { __typename: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string, userRoles: { __typename: 'PaginatedSuperUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> }> } };

export type SuperUserRoleFragment = { __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename: 'PaginatedSuperUserResponseType', itemCount: number, items: Array<{ __typename: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string }> }, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> };

export type SuperUserRoleForSelectFragment = { __typename: 'SuperUserRoleResponseType', userRoleId: string, name: string, isSystemRole: boolean, groupId?: string, objectVersion?: number };

export type OwnSuperUserRoleFragment = { __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> };

export type SuperUserRoleLinkFragment = { __typename: 'SuperUserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number };

export type FeatureFlagFragmentFragment = { __typename: 'FeatureFlagType', featureName: string, isEnabled: boolean, description?: string };

export type BackofficeResourceGroupUserInfoFragment = { __typename: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: Types.UserSourceEnum };

export type BackofficeSubGroupFragment = { __typename: 'BackofficeResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any, fullPaths: Array<string> };

export type BackofficeGroupTreeItemFragment = { __typename: 'BackofficeResourceGroupResponseType', groupId: string, name: string, parentGroupId?: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, fullPaths: Array<string> };

export type BackofficeResourceGroupForSelectFragment = { __typename: 'BackofficeResourceGroupResponseType', groupId: string, parentGroupId?: string, name: string, fullPaths: Array<string> };

export type BackofficeResourceGroupFragment = { __typename: 'BackofficeResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, groupType: Types.ResourceGroupTypeEnum, isSystemGroup: boolean, fullPaths: Array<string>, updateUser?: { __typename: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: Types.UserSourceEnum }, creationUser?: { __typename: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: Types.UserSourceEnum }, subGroups: { __typename: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any, fullPaths: Array<string> }> } };

export type LoginTenantForSuperTenantMutationVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
}>;


export type LoginTenantForSuperTenantMutation = { __typename: 'Mutation', loginTenant: { __typename: 'LoginTenantResponseType', idToken: string } };

export type ActivateTenantMutationVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
}>;


export type ActivateTenantMutation = { __typename: 'Mutation', activateTenant: { __typename: 'TenantResponseType', tenantId: string } };

export type UpdateBackofficeTenantMutationVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  tenant: Types.UpdateTenantInput;
}>;


export type UpdateBackofficeTenantMutation = { __typename: 'Mutation', updateTenant: { __typename: 'TenantResponseType', tenantId: string } };

export type UpdateTenantSecuritySettingsMutationVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  tenant: Types.UpdateTenantSecuritySettingsInput;
}>;


export type UpdateTenantSecuritySettingsMutation = { __typename: 'Mutation', updateTenantSecuritySettings: { __typename: 'TenantResponseType', tenantId: string } };

export type CreateSuperUserMutationVariables = Types.Exact<{
  user: Types.CreateSuperUserInput;
}>;


export type CreateSuperUserMutation = { __typename: 'Mutation', createUser: { __typename: 'SuperUserResponseType', userId: string } };

export type UpdateSuperUserMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
  user: Types.UpdateSuperUserInput;
}>;


export type UpdateSuperUserMutation = { __typename: 'Mutation', updateUser: { __typename: 'SuperUserResponseType', userId: string } };

export type DeleteSuperUserMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
}>;


export type DeleteSuperUserMutation = { __typename: 'Mutation', deleteUser: { __typename: 'SuperUserResponseType', userId: string } };

export type CreateSuperUserRoleMutationVariables = Types.Exact<{
  userRole: Types.CreateSuperUserRoleInput;
}>;


export type CreateSuperUserRoleMutation = { __typename: 'Mutation', createUserRole: { __typename: 'SuperUserRoleResponseType', userRoleId: string } };

export type UpdateSuperUserRoleMutationVariables = Types.Exact<{
  userRoleId: Types.Scalars['String']['input'];
  userRole: Types.UpdateSuperUserRoleInput;
}>;


export type UpdateSuperUserRoleMutation = { __typename: 'Mutation', updateUserRole: { __typename: 'SuperUserRoleResponseType', userRoleId: string } };

export type DeleteSuperUserRoleMutationVariables = Types.Exact<{
  userRoleId: Types.Scalars['String']['input'];
}>;


export type DeleteSuperUserRoleMutation = { __typename: 'Mutation', deleteUserRole: { __typename: 'SuperUserRoleResponseType', userRoleId: string, users: { __typename: 'PaginatedSuperUserResponseType', items: Array<{ __typename: 'SuperUserResponseType', userId: string }> } } };

export type CreateSuperUserRoleUserLinkMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
  userRoleId: Types.Scalars['String']['input'];
  expirationTimestamp?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type CreateSuperUserRoleUserLinkMutation = { __typename: 'Mutation', createUserRoleUserLink: { __typename: 'SuperUserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number } };

export type DeleteSuperUserRoleUserLinkMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
  userRoleId: Types.Scalars['String']['input'];
}>;


export type DeleteSuperUserRoleUserLinkMutation = { __typename: 'Mutation', deleteUserRoleUserLink?: any };

export type UpdateSuperUserRoleUserLinkMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
  userRoleId: Types.Scalars['String']['input'];
  expirationTimestamp?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  objectVersion?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UpdateSuperUserRoleUserLinkMutation = { __typename: 'Mutation', updateUserRoleUserLink: { __typename: 'SuperUserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number } };

export type CreateBackofficeResourceGroupMutationVariables = Types.Exact<{
  resourceGroup: Types.CreateBackofficeResourceGroupInput;
}>;


export type CreateBackofficeResourceGroupMutation = { __typename: 'Mutation', createResourceGroup: { __typename: 'BackofficeResourceGroupResponseType', groupId: string, parentGroupId?: string } };

export type UpdateBackofficeResourceGroupMutationVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
  resourceGroup: Types.UpdateBackofficeResourceGroupInput;
}>;


export type UpdateBackofficeResourceGroupMutation = { __typename: 'Mutation', updateResourceGroup: { __typename: 'BackofficeResourceGroupResponseType', groupId: string, parentGroupId?: string } };

export type DeleteBackofficeResourceGroupMutationVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
}>;


export type DeleteBackofficeResourceGroupMutation = { __typename: 'Mutation', deleteResourceGroup: { __typename: 'BackofficeResourceGroupResponseType', groupId: string, parentGroupId?: string } };

export type UpdateSuperUserUiPreferencesMutationVariables = Types.Exact<{
  uiPreferences?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
  objectVersion?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UpdateSuperUserUiPreferencesMutation = { __typename: 'Mutation', updateUserUiPreferences: { __typename: 'SuperUserUiPreferencesResponseType', uiPreferences?: any, objectVersion?: number } };

export type CreateSuperTenantFeatureFlagMutationVariables = Types.Exact<{
  superTenantId: Types.Scalars['String']['input'];
  flag: Types.CreateFeatureFlagInput;
}>;


export type CreateSuperTenantFeatureFlagMutation = { __typename: 'Mutation', createSuperTenantFeatureFlag: { __typename: 'SuperTenantResponseType', superTenantId: string } };

export type UpdateSuperTenantFeatureFlagMutationVariables = Types.Exact<{
  superTenantId: Types.Scalars['String']['input'];
  flag: Types.UpdateFeatureFlagInput;
}>;


export type UpdateSuperTenantFeatureFlagMutation = { __typename: 'Mutation', updateSuperTenantFeatureFlag: { __typename: 'SuperTenantResponseType', superTenantId: string } };

export type DeleteSuperTenantFeatureFlagMutationVariables = Types.Exact<{
  superTenantId: Types.Scalars['String']['input'];
  featureName: Types.Scalars['String']['input'];
  cascade: Types.Scalars['Boolean']['input'];
}>;


export type DeleteSuperTenantFeatureFlagMutation = { __typename: 'Mutation', deleteSuperTenantFeatureFlag: { __typename: 'DeleteFeatureFlagResponseType', featureName: string, affectedTenantIds: Array<string> } };

export type UpdateGlobalOrchestratorConfigMutationVariables = Types.Exact<{
  config: Types.UpdateGlobalOrchestratorConfigInput;
}>;


export type UpdateGlobalOrchestratorConfigMutation = { __typename: 'Mutation', updateGlobalOrchestratorConfig: { __typename: 'GlobalOrchestratorConfigResponseType', lastActiveTagKey: string, dryRun: boolean, logLevel: string, region: string, regions: Array<string>, emaAlpha: number, emaEnabled: boolean, objectVersion?: number } };

export type CreateIdeOrchestratorConfigMutationVariables = Types.Exact<{
  config: Types.CreateIdeOrchestratorConfigInput;
}>;


export type CreateIdeOrchestratorConfigMutation = { __typename: 'Mutation', createIdeOrchestratorConfig: { __typename: 'IdeOrchestratorConfigResponseType', ideName: string, minInstances: number, maxInstances: number, hibernationPoolSize: number, idleThresholdSeconds: number, messagesPerInstance: number, maxMessageAgeSeconds: number, urgencyExtraInstances: number, enabled: boolean, objectVersion?: number } };

export type UpdateIdeOrchestratorConfigMutationVariables = Types.Exact<{
  ideName: Types.Scalars['String']['input'];
  config: Types.UpdateIdeOrchestratorConfigInput;
}>;


export type UpdateIdeOrchestratorConfigMutation = { __typename: 'Mutation', updateIdeOrchestratorConfig: { __typename: 'IdeOrchestratorConfigResponseType', ideName: string, minInstances: number, maxInstances: number, hibernationPoolSize: number, idleThresholdSeconds: number, messagesPerInstance: number, maxMessageAgeSeconds: number, urgencyExtraInstances: number, enabled: boolean, objectVersion?: number } };

export type DeleteIdeOrchestratorConfigMutationVariables = Types.Exact<{
  ideName: Types.Scalars['String']['input'];
}>;


export type DeleteIdeOrchestratorConfigMutation = { __typename: 'Mutation', deleteIdeOrchestratorConfig: boolean };

export type CreateIdeOrchestratorConfigOverrideMutationVariables = Types.Exact<{
  override: Types.CreateIdeOrchestratorConfigOverrideInput;
}>;


export type CreateIdeOrchestratorConfigOverrideMutation = { __typename: 'Mutation', createIdeOrchestratorConfigOverride: { __typename: 'IdeOrchestratorConfigOverrideResponseType', ideName: string, region: string, minInstances?: number, maxInstances?: number, hibernationPoolSize?: number, objectVersion?: number } };

export type UpdateIdeOrchestratorConfigOverrideMutationVariables = Types.Exact<{
  ideName: Types.Scalars['String']['input'];
  region: Types.Scalars['String']['input'];
  override: Types.UpdateIdeOrchestratorConfigOverrideInput;
}>;


export type UpdateIdeOrchestratorConfigOverrideMutation = { __typename: 'Mutation', updateIdeOrchestratorConfigOverride: { __typename: 'IdeOrchestratorConfigOverrideResponseType', ideName: string, region: string, minInstances?: number, maxInstances?: number, hibernationPoolSize?: number, objectVersion?: number } };

export type DeleteIdeOrchestratorConfigOverrideMutationVariables = Types.Exact<{
  ideName: Types.Scalars['String']['input'];
  region: Types.Scalars['String']['input'];
}>;


export type DeleteIdeOrchestratorConfigOverrideMutation = { __typename: 'Mutation', deleteIdeOrchestratorConfigOverride: boolean };

export type ReadTenantsForSuperTenantQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TenantFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadTenantsForSuperTenantQuery = { __typename: 'Query', readTenantsForSuperTenant: { __typename: 'PaginatedTenantResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'TenantResponseType', tenantId: string, companyName: string, country?: string, ssoEnabled?: boolean, objectVersion?: number, creationTimestamp?: any, industry?: string, isActive: boolean, groupId?: string, metaData?: any, owner?: { __typename: 'LightUserResponseType', userId: string, firstName: string, lastName: string, email: string, source: Types.UserSourceEnum, isSystemUser?: boolean, termsAndConditions: { __typename: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, acceptedTimestamp?: any, termsAndConditionsVersion?: number, latestTermsAndConditionsVersionAccepted: boolean } } }> } };

export type ReadTenantForSuperTenantQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
}>;


export type ReadTenantForSuperTenantQuery = { __typename: 'Query', readTenant: { __typename: 'TenantResponseType', tenantId: string, companyName: string, country?: string, ssoEnabled?: boolean, objectVersion?: number, creationTimestamp?: any, industry?: string, isActive: boolean, groupId?: string, metaData?: any, owner?: { __typename: 'LightUserResponseType', userId: string, firstName: string, lastName: string, email: string, source: Types.UserSourceEnum, isSystemUser?: boolean, termsAndConditions: { __typename: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, acceptedTimestamp?: any, termsAndConditionsVersion?: number, latestTermsAndConditionsVersionAccepted: boolean } } } };

export type ReadTenantFeatureFlagsQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
}>;


export type ReadTenantFeatureFlagsQuery = { __typename: 'Query', readTenant: { __typename: 'TenantResponseType', tenantId: string, objectVersion?: number, featureFlags?: Array<{ __typename: 'FeatureFlagType', featureName: string, isEnabled: boolean, description?: string }> } };

export type ReadTenantForUpdateQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
}>;


export type ReadTenantForUpdateQuery = { __typename: 'Query', readTenant: { __typename: 'TenantResponseType', tenantId: string, objectVersion?: number, ownerId: string, groupId?: string, ssoEnabled?: boolean, metaData?: any, users: { __typename: 'PaginatedLightUserResponseType', itemCount: number, items: Array<{ __typename: 'LightUserResponseType', userId: string, firstName: string, lastName: string, email: string, source: Types.UserSourceEnum, isSystemUser?: boolean, termsAndConditions: { __typename: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, acceptedTimestamp?: any, termsAndConditionsVersion?: number, latestTermsAndConditionsVersionAccepted: boolean } }> } } };

export type ReadAllSuperUserRolesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SuperUserRoleFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllSuperUserRolesQuery = { __typename: 'Query', readAllUserRoles: { __typename: 'PaginatedSuperUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename: 'PaginatedSuperUserResponseType', itemCount: number, items: Array<{ __typename: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string }> }, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> }> } };

export type ReadSuperUserRolesForSelectQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SuperUserRoleFilterInput>;
}>;


export type ReadSuperUserRolesForSelectQuery = { __typename: 'Query', readAllUserRoles: { __typename: 'PaginatedSuperUserRoleResponseType', items: Array<{ __typename: 'SuperUserRoleResponseType', userRoleId: string, name: string, isSystemRole: boolean, groupId?: string, objectVersion?: number }> } };

export type ReadSuperUserRoleQueryVariables = Types.Exact<{
  userRoleId: Types.Scalars['String']['input'];
}>;


export type ReadSuperUserRoleQuery = { __typename: 'Query', readUserRole: { __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename: 'PaginatedSuperUserResponseType', itemCount: number, items: Array<{ __typename: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string }> }, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> } };

export type ReadSuperUserRolesForOwnUserQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadSuperUserRolesForOwnUserQuery = { __typename: 'Query', readSuperUserRolesForOwnUser: { __typename: 'PaginatedSuperUserRoleResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> }> } };

export type ReadAllSuperUsersQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SuperUserFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllSuperUsersQuery = { __typename: 'Query', readAllUsers: { __typename: 'PaginatedSuperUserResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string, userRoles: { __typename: 'PaginatedSuperUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> }> } }> } };

export type ReadSuperUsersForSelectQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SuperUserFilterInput>;
}>;


export type ReadSuperUsersForSelectQuery = { __typename: 'Query', readAllUsers: { __typename: 'PaginatedSuperUserResponseType', items: Array<{ __typename: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, email: string, source: Types.UserSourceEnum, groupId?: string, objectVersion?: number, userRoles: { __typename: 'PaginatedSuperUserRoleResponseType', items: Array<{ __typename: 'SuperUserRoleResponseType', isSystemRole: boolean }> } }> } };

export type ReadSuperUserQueryVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
}>;


export type ReadSuperUserQuery = { __typename: 'Query', readUser: { __typename: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string, userRoles: { __typename: 'PaginatedSuperUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> }> } } };

export type ReadSuperUsersForUserRoleQueryVariables = Types.Exact<{
  userRoleId: Types.Scalars['String']['input'];
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadSuperUsersForUserRoleQuery = { __typename: 'Query', readUsersForUserRole: { __typename: 'PaginatedSuperUserResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string, userRoles: { __typename: 'PaginatedSuperUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> }> } }> } };

export type ReadSuperUserRoleUserLinksForUserQueryVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
}>;


export type ReadSuperUserRoleUserLinksForUserQuery = { __typename: 'Query', readUserRoleUserLinksForUser: { __typename: 'PaginatedSuperUserRoleUserLinkResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'SuperUserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number }> } };

export type ReadSuperUserRoleUserLinksForUserRoleQueryVariables = Types.Exact<{
  userRoleId: Types.Scalars['String']['input'];
}>;


export type ReadSuperUserRoleUserLinksForUserRoleQuery = { __typename: 'Query', readUserRoleUserLinksForUserRole: { __typename: 'PaginatedSuperUserRoleUserLinkResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'SuperUserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number }> } };

export type ReadSuperTenantQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadSuperTenantQuery = { __typename: 'Query', readSuperTenant: { __typename: 'SuperTenantResponseType', superTenantId: string, identifier: string, companyName: string, featureFlags?: Array<{ __typename: 'FeatureFlagType', featureName: string, isEnabled: boolean, description?: string }> } };

export type ReadBackofficeResourceGroupByIdQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
}>;


export type ReadBackofficeResourceGroupByIdQuery = { __typename: 'Query', readResourceGroup: { __typename: 'BackofficeResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, groupType: Types.ResourceGroupTypeEnum, isSystemGroup: boolean, fullPaths: Array<string>, updateUser?: { __typename: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: Types.UserSourceEnum }, creationUser?: { __typename: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: Types.UserSourceEnum }, subGroups: { __typename: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any, fullPaths: Array<string> }> } }, readSubGroupsForResourceGroup: { __typename: 'PaginatedBackofficeResourceGroupResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, groupType: Types.ResourceGroupTypeEnum, isSystemGroup: boolean, fullPaths: Array<string>, updateUser?: { __typename: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: Types.UserSourceEnum }, creationUser?: { __typename: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: Types.UserSourceEnum }, subGroups: { __typename: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any, fullPaths: Array<string> }> } }> } };

export type ReadBackofficeResourceGroupsToBuildTreeQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.BackofficeResourceGroupFilterInput>;
}>;


export type ReadBackofficeResourceGroupsToBuildTreeQuery = { __typename: 'Query', readAllResourceGroups: { __typename: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', groupId: string, name: string, parentGroupId?: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, fullPaths: Array<string> }> } };

export type ReadAllBackofficeResourceGroupsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.BackofficeResourceGroupFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllBackofficeResourceGroupsQuery = { __typename: 'Query', readAllResourceGroups: { __typename: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, groupType: Types.ResourceGroupTypeEnum, isSystemGroup: boolean, fullPaths: Array<string>, updateUser?: { __typename: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: Types.UserSourceEnum }, creationUser?: { __typename: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: Types.UserSourceEnum }, subGroups: { __typename: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any, fullPaths: Array<string> }> } }> } };

export type ReadBackofficeResourceGroupsForSelectQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.BackofficeResourceGroupFilterInput>;
}>;


export type ReadBackofficeResourceGroupsForSelectQuery = { __typename: 'Query', readAllResourceGroups: { __typename: 'PaginatedBackofficeResourceGroupResponseType', items: Array<{ __typename: 'BackofficeResourceGroupResponseType', groupId: string, parentGroupId?: string, name: string, fullPaths: Array<string> }> } };

export type ReadSubGroupsForBackofficeResourceGroupQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadSubGroupsForBackofficeResourceGroupQuery = { __typename: 'Query', readSubGroupsForResourceGroup: { __typename: 'PaginatedBackofficeResourceGroupResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, groupType: Types.ResourceGroupTypeEnum, isSystemGroup: boolean, fullPaths: Array<string>, updateUser?: { __typename: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: Types.UserSourceEnum }, creationUser?: { __typename: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: Types.UserSourceEnum }, subGroups: { __typename: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any, fullPaths: Array<string> }> } }> } };

export type ReadBackofficeResourceGroupNamesForRoleRowQueryVariables = Types.Exact<{
  groupIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadBackofficeResourceGroupNamesForRoleRowQuery = { __typename: 'Query', readResourceGroupsByIds: { __typename: 'PaginatedBackofficeResourceGroupResponseType', items: Array<{ __typename: 'BackofficeResourceGroupResponseType', name: string, groupId: string, parentGroupId?: string }> } };

export type ReadBackofficeResourceGroupNameByIdQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
}>;


export type ReadBackofficeResourceGroupNameByIdQuery = { __typename: 'Query', readResourceGroup: { __typename: 'BackofficeResourceGroupResponseType', name: string, parentGroupId?: string, fullPaths: Array<string> } };

export type ReadBackofficeGroupResourceCountsQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
}>;


export type ReadBackofficeGroupResourceCountsQuery = { __typename: 'Query', readBackofficeResourceGroup: { __typename: 'BackofficeResourceGroupResponseType', groupId: string, subGroups: { __typename: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number }, tenants: { __typename: 'PaginatedTenantResponseType', itemCount: number } }, groupUsers: { __typename: 'PaginatedSuperUserResponseType', itemCount: number }, groupRoles: { __typename: 'PaginatedSuperUserRoleResponseType', itemCount: number } };

export type ReadBackofficeUngroupedResourceCountsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadBackofficeUngroupedResourceCountsQuery = { __typename: 'Query', groupUsers: { __typename: 'PaginatedSuperUserResponseType', itemCount: number }, groupRoles: { __typename: 'PaginatedSuperUserRoleResponseType', itemCount: number }, groupTenants: { __typename: 'PaginatedTenantResponseType', itemCount: number } };

export type ReadSuperUserUiPreferencesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadSuperUserUiPreferencesQuery = { __typename: 'Query', readUserUiPreferences: { __typename: 'SuperUserUiPreferencesResponseType', uiPreferences?: any, objectVersion?: number } };

export type ReadGlobalOrchestratorConfigQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadGlobalOrchestratorConfigQuery = { __typename: 'Query', readGlobalOrchestratorConfig: { __typename: 'GlobalOrchestratorConfigResponseType', lastActiveTagKey: string, dryRun: boolean, logLevel: string, region: string, regions: Array<string>, emaAlpha: number, emaEnabled: boolean, objectVersion?: number } };

export type ListIdeOrchestratorConfigsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ListIdeOrchestratorConfigsQuery = { __typename: 'Query', listIdeOrchestratorConfigs: Array<{ __typename: 'IdeOrchestratorConfigResponseType', ideName: string, minInstances: number, maxInstances: number, hibernationPoolSize: number, idleThresholdSeconds: number, messagesPerInstance: number, maxMessageAgeSeconds: number, urgencyExtraInstances: number, enabled: boolean, objectVersion?: number }> };

export type ListAllIdeOrchestratorConfigOverridesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ListAllIdeOrchestratorConfigOverridesQuery = { __typename: 'Query', listAllIdeOrchestratorConfigOverrides: Array<{ __typename: 'IdeOrchestratorConfigOverrideResponseType', ideName: string, region: string, minInstances?: number, maxInstances?: number, hibernationPoolSize?: number, objectVersion?: number }> };

export type ListConfigChangeHistoryQueryVariables = Types.Exact<{
  scope?: Types.InputMaybe<Types.ConfigChangeScopeInput>;
  startTime?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  endTime?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ListConfigChangeHistoryQuery = { __typename: 'Query', listConfigChangeHistory: { __typename: 'PaginatedConfigChangeResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'ConfigChangeResponseType', changeId: string, scopeType: Types.ConfigChangeScopeType, ideName?: string, region?: string, operation: Types.ConfigChangeOperation, oldConfig?: any, newConfig?: any, changedBy: string, changedAt: string, status: Types.ConfigChangeStatus, appliedAt?: string, appliedRunId?: string }> } };

export type FleetCapacityMetricsQueryVariables = Types.Exact<{
  startTime: Types.Scalars['DateTime']['input'];
  endTime: Types.Scalars['DateTime']['input'];
  periodSeconds?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  ideName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  region?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type FleetCapacityMetricsQuery = { __typename: 'Query', fleetCapacityMetrics: { __typename: 'FleetCapacityMetricsResultType', series: Array<{ __typename: 'MetricSeriesType', name: string, unit: string, source: Types.MetricSource, points: Array<{ __typename: 'MetricPointType', timestamp: string, value: number }> }> } };

export type ReadSuperUserNamesQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadSuperUserNamesQuery = { __typename: 'Query', readSuperUserNames: { __typename: 'PaginatedSuperUserResponseType', itemCount: number, items: Array<{ __typename: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, email: string }> } };

export type ReadOrchestratorRunStatusQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadOrchestratorRunStatusQuery = { __typename: 'Query', readOrchestratorRunStatus: { __typename: 'RunStatusResultType', pages: number, itemCount: number, lastRunAgeSeconds?: number, isStale: boolean, expectedIntervalSeconds: number, items: Array<{ __typename: 'RunStatusEntryType', startedAt: string, requestId: string, triggerType: string, durationMs: number, asgsTotal: number, asgsOk: number, asgsError: number, asgsSkipped: number, dryRun: boolean, results: any }> } };

export type ReadUiSpeedSummaryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadUiSpeedSummaryQuery = { __typename: 'Query', readUiSpeedSummary: { __typename: 'UiSpeedSummaryResponseType', summary: any } };

export type ReadSreHubSummaryQueryVariables = Types.Exact<{
  indicator: Types.SreHubIndicator;
}>;


export type ReadSreHubSummaryQuery = { __typename: 'Query', readSreHubSummary: { __typename: 'SreHubSummaryResponseType', summary: any } };

export type ReadSuperTenantFeatureFlagCatalogsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadSuperTenantFeatureFlagCatalogsQuery = { __typename: 'Query', readAllSuperTenants: Array<{ __typename: 'SuperTenantResponseType', superTenantId: string, identifier: string, featureFlags?: Array<{ __typename: 'FeatureFlagType', featureName: string, description?: string, isPublished: boolean }> }> };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const BackofficeUserInfoFragmentDoc = new TypedDocumentString(`
    fragment BackofficeUserInfo on LightUserResponseType {
  __typename
  userId
  firstName
  lastName
  email
  source
  isSystemUser
  termsAndConditions {
    __typename
    accepted
    acceptedTimestamp
    termsAndConditionsVersion
    latestTermsAndConditionsVersionAccepted
  }
}
    `, {"fragmentName":"BackofficeUserInfo"});
export const BackofficeTenantFragmentDoc = new TypedDocumentString(`
    fragment BackofficeTenant on TenantResponseType {
  __typename
  tenantId
  companyName
  owner {
    __typename
    ...BackofficeUserInfo
  }
  country
  ssoEnabled
  objectVersion
  creationTimestamp
  industry
  isActive
  groupId
  metaData
}
    fragment BackofficeUserInfo on LightUserResponseType {
  __typename
  userId
  firstName
  lastName
  email
  source
  isSystemUser
  termsAndConditions {
    __typename
    accepted
    acceptedTimestamp
    termsAndConditionsVersion
    latestTermsAndConditionsVersionAccepted
  }
}`, {"fragmentName":"BackofficeTenant"});
export const SuperUserForSelectFragmentDoc = new TypedDocumentString(`
    fragment SuperUserForSelect on SuperUserResponseType {
  __typename
  userId
  firstName
  lastName
  email
  source
  groupId
  objectVersion
  userRoles {
    __typename
    items {
      __typename
      isSystemRole
    }
  }
}
    `, {"fragmentName":"SuperUserForSelect"});
export const BaseSuperUserFragmentDoc = new TypedDocumentString(`
    fragment BaseSuperUser on SuperUserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
}
    `, {"fragmentName":"BaseSuperUser"});
export const SuperUserPolicyFragmentDoc = new TypedDocumentString(`
    fragment SuperUserPolicy on PolicyType {
  __typename
  name
  action
  resource
  description
}
    `, {"fragmentName":"SuperUserPolicy"});
export const OwnSuperUserRoleFragmentDoc = new TypedDocumentString(`
    fragment OwnSuperUserRole on SuperUserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  policies {
    __typename
    ...SuperUserPolicy
  }
  groupId
}
    fragment SuperUserPolicy on PolicyType {
  __typename
  name
  action
  resource
  description
}`, {"fragmentName":"OwnSuperUserRole"});
export const SuperUserFragmentDoc = new TypedDocumentString(`
    fragment SuperUser on SuperUserResponseType {
  __typename
  ...BaseSuperUser
  userRoles {
    __typename
    items {
      __typename
      ...OwnSuperUserRole
    }
    pages
    itemCount
  }
}
    fragment SuperUserPolicy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment BaseSuperUser on SuperUserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
}
fragment OwnSuperUserRole on SuperUserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  policies {
    __typename
    ...SuperUserPolicy
  }
  groupId
}`, {"fragmentName":"SuperUser"});
export const SuperUserRoleFragmentDoc = new TypedDocumentString(`
    fragment SuperUserRole on SuperUserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  users {
    __typename
    itemCount
    items {
      __typename
      ...BaseSuperUser
    }
  }
  policies {
    __typename
    ...SuperUserPolicy
  }
  groupId
}
    fragment SuperUserPolicy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment BaseSuperUser on SuperUserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
}`, {"fragmentName":"SuperUserRole"});
export const SuperUserRoleForSelectFragmentDoc = new TypedDocumentString(`
    fragment SuperUserRoleForSelect on SuperUserRoleResponseType {
  __typename
  userRoleId
  name
  isSystemRole
  groupId
  objectVersion
}
    `, {"fragmentName":"SuperUserRoleForSelect"});
export const SuperUserRoleLinkFragmentDoc = new TypedDocumentString(`
    fragment SuperUserRoleLink on SuperUserRoleUserLinkResponseType {
  __typename
  expirationTimestamp
  userId
  userRoleId
  objectVersion
}
    `, {"fragmentName":"SuperUserRoleLink"});
export const FeatureFlagFragmentFragmentDoc = new TypedDocumentString(`
    fragment FeatureFlagFragment on FeatureFlagType {
  __typename
  featureName
  isEnabled
  description
}
    `, {"fragmentName":"FeatureFlagFragment"});
export const BackofficeGroupTreeItemFragmentDoc = new TypedDocumentString(`
    fragment BackofficeGroupTreeItem on BackofficeResourceGroupResponseType {
  __typename
  groupId
  name
  parentGroupId
  creationTimestamp
  updateTimestamp
  objectVersion
  fullPaths
}
    `, {"fragmentName":"BackofficeGroupTreeItem"});
export const BackofficeResourceGroupForSelectFragmentDoc = new TypedDocumentString(`
    fragment BackofficeResourceGroupForSelect on BackofficeResourceGroupResponseType {
  __typename
  groupId
  parentGroupId
  name
  fullPaths
}
    `, {"fragmentName":"BackofficeResourceGroupForSelect"});
export const BackofficeResourceGroupUserInfoFragmentDoc = new TypedDocumentString(`
    fragment BackofficeResourceGroupUserInfo on LightSuperUserResponseType {
  __typename
  firstName
  lastName
  email
  source
}
    `, {"fragmentName":"BackofficeResourceGroupUserInfo"});
export const BackofficeSubGroupFragmentDoc = new TypedDocumentString(`
    fragment BackofficeSubGroup on BackofficeResourceGroupResponseType {
  __typename
  name
  groupId
  creationTimestamp
  updateTimestamp
  fullPaths
}
    `, {"fragmentName":"BackofficeSubGroup"});
export const BackofficeResourceGroupFragmentDoc = new TypedDocumentString(`
    fragment BackofficeResourceGroup on BackofficeResourceGroupResponseType {
  __typename
  updateUser {
    __typename
    ...BackofficeResourceGroupUserInfo
  }
  creationUser {
    __typename
    ...BackofficeResourceGroupUserInfo
  }
  updateTimestamp
  creationTimestamp
  name
  parentGroupId
  groupId
  objectVersion
  groupType
  isSystemGroup
  subGroups {
    __typename
    itemCount
    items {
      __typename
      ...BackofficeSubGroup
    }
    pages
  }
  fullPaths
}
    fragment BackofficeResourceGroupUserInfo on LightSuperUserResponseType {
  __typename
  firstName
  lastName
  email
  source
}
fragment BackofficeSubGroup on BackofficeResourceGroupResponseType {
  __typename
  name
  groupId
  creationTimestamp
  updateTimestamp
  fullPaths
}`, {"fragmentName":"BackofficeResourceGroup"});
export const LoginTenantForSuperTenantDocument = new TypedDocumentString(`
    mutation LoginTenantForSuperTenant($tenantId: String!) {
  __typename
  loginTenant(tenantId: $tenantId) {
    __typename
    idToken
  }
}
    `);
export const ActivateTenantDocument = new TypedDocumentString(`
    mutation ActivateTenant($tenantId: String!) {
  __typename
  activateTenant(tenantId: $tenantId) {
    __typename
    tenantId
  }
}
    `);
export const UpdateBackofficeTenantDocument = new TypedDocumentString(`
    mutation UpdateBackofficeTenant($tenantId: String!, $tenant: UpdateTenantInput!) {
  __typename
  updateTenant(tenantId: $tenantId, tenant: $tenant) {
    __typename
    tenantId
  }
}
    `);
export const UpdateTenantSecuritySettingsDocument = new TypedDocumentString(`
    mutation UpdateTenantSecuritySettings($tenantId: String!, $tenant: UpdateTenantSecuritySettingsInput!) {
  __typename
  updateTenantSecuritySettings(tenantId: $tenantId, tenant: $tenant) {
    __typename
    tenantId
  }
}
    `);
export const CreateSuperUserDocument = new TypedDocumentString(`
    mutation CreateSuperUser($user: CreateSuperUserInput!) {
  __typename
  createUser: createSuperUser(user: $user) {
    __typename
    userId
  }
}
    `);
export const UpdateSuperUserDocument = new TypedDocumentString(`
    mutation UpdateSuperUser($userId: String!, $user: UpdateSuperUserInput!) {
  __typename
  updateUser: updateSuperUser(userId: $userId, user: $user) {
    __typename
    userId
  }
}
    `);
export const DeleteSuperUserDocument = new TypedDocumentString(`
    mutation DeleteSuperUser($userId: String!) {
  __typename
  deleteUser: deleteSuperUser(userId: $userId) {
    __typename
    userId
  }
}
    `);
export const CreateSuperUserRoleDocument = new TypedDocumentString(`
    mutation CreateSuperUserRole($userRole: CreateSuperUserRoleInput!) {
  __typename
  createUserRole: createSuperUserRole(userRole: $userRole) {
    __typename
    userRoleId
  }
}
    `);
export const UpdateSuperUserRoleDocument = new TypedDocumentString(`
    mutation UpdateSuperUserRole($userRoleId: String!, $userRole: UpdateSuperUserRoleInput!) {
  __typename
  updateUserRole: updateSuperUserRole(
    userRoleId: $userRoleId
    userRole: $userRole
  ) {
    __typename
    userRoleId
  }
}
    `);
export const DeleteSuperUserRoleDocument = new TypedDocumentString(`
    mutation DeleteSuperUserRole($userRoleId: String!) {
  __typename
  deleteUserRole: deleteSuperUserRole(userRoleId: $userRoleId) {
    __typename
    userRoleId
    users {
      __typename
      items {
        __typename
        userId
      }
    }
  }
}
    `);
export const CreateSuperUserRoleUserLinkDocument = new TypedDocumentString(`
    mutation CreateSuperUserRoleUserLink($userId: String!, $userRoleId: String!, $expirationTimestamp: DateTime) {
  __typename
  createUserRoleUserLink: createSuperUserRoleUserLink(
    userId: $userId
    userRoleId: $userRoleId
    input: {expirationTimestamp: $expirationTimestamp}
  ) {
    __typename
    ...SuperUserRoleLink
  }
}
    fragment SuperUserRoleLink on SuperUserRoleUserLinkResponseType {
  __typename
  expirationTimestamp
  userId
  userRoleId
  objectVersion
}`);
export const DeleteSuperUserRoleUserLinkDocument = new TypedDocumentString(`
    mutation DeleteSuperUserRoleUserLink($userId: String!, $userRoleId: String!) {
  __typename
  deleteUserRoleUserLink: deleteSuperUserRoleUserLink(
    userId: $userId
    userRoleId: $userRoleId
  )
}
    `);
export const UpdateSuperUserRoleUserLinkDocument = new TypedDocumentString(`
    mutation UpdateSuperUserRoleUserLink($userId: String!, $userRoleId: String!, $expirationTimestamp: DateTime, $objectVersion: Int) {
  __typename
  updateUserRoleUserLink: updateSuperUserRoleUserLink(
    userId: $userId
    userRoleId: $userRoleId
    input: {expirationTimestamp: $expirationTimestamp, objectVersion: $objectVersion}
  ) {
    __typename
    ...SuperUserRoleLink
  }
}
    fragment SuperUserRoleLink on SuperUserRoleUserLinkResponseType {
  __typename
  expirationTimestamp
  userId
  userRoleId
  objectVersion
}`);
export const CreateBackofficeResourceGroupDocument = new TypedDocumentString(`
    mutation CreateBackofficeResourceGroup($resourceGroup: CreateBackofficeResourceGroupInput!) {
  __typename
  createResourceGroup: createBackofficeResourceGroup(
    backofficeResourceGroup: $resourceGroup
  ) {
    __typename
    groupId
    parentGroupId
  }
}
    `);
export const UpdateBackofficeResourceGroupDocument = new TypedDocumentString(`
    mutation UpdateBackofficeResourceGroup($groupId: String!, $resourceGroup: UpdateBackofficeResourceGroupInput!) {
  __typename
  updateResourceGroup: updateBackofficeResourceGroup(
    groupId: $groupId
    backofficeResourceGroup: $resourceGroup
  ) {
    __typename
    groupId
    parentGroupId
  }
}
    `);
export const DeleteBackofficeResourceGroupDocument = new TypedDocumentString(`
    mutation DeleteBackofficeResourceGroup($groupId: String!) {
  __typename
  deleteResourceGroup: deleteBackofficeResourceGroup(groupId: $groupId) {
    __typename
    groupId
    parentGroupId
  }
}
    `);
export const UpdateSuperUserUiPreferencesDocument = new TypedDocumentString(`
    mutation UpdateSuperUserUiPreferences($uiPreferences: JSON, $objectVersion: Int) {
  __typename
  updateUserUiPreferences: updateSuperUserUiPreferences(
    uiPreferences: $uiPreferences
    objectVersion: $objectVersion
  ) {
    __typename
    uiPreferences
    objectVersion
  }
}
    `);
export const CreateSuperTenantFeatureFlagDocument = new TypedDocumentString(`
    mutation CreateSuperTenantFeatureFlag($superTenantId: String!, $flag: CreateFeatureFlagInput!) {
  __typename
  createSuperTenantFeatureFlag(superTenantId: $superTenantId, flag: $flag) {
    __typename
    superTenantId
  }
}
    `);
export const UpdateSuperTenantFeatureFlagDocument = new TypedDocumentString(`
    mutation UpdateSuperTenantFeatureFlag($superTenantId: String!, $flag: UpdateFeatureFlagInput!) {
  __typename
  updateSuperTenantFeatureFlag(superTenantId: $superTenantId, flag: $flag) {
    __typename
    superTenantId
  }
}
    `);
export const DeleteSuperTenantFeatureFlagDocument = new TypedDocumentString(`
    mutation DeleteSuperTenantFeatureFlag($superTenantId: String!, $featureName: String!, $cascade: Boolean!) {
  __typename
  deleteSuperTenantFeatureFlag(
    superTenantId: $superTenantId
    featureName: $featureName
    cascade: $cascade
  ) {
    __typename
    featureName
    affectedTenantIds
  }
}
    `);
export const UpdateGlobalOrchestratorConfigDocument = new TypedDocumentString(`
    mutation UpdateGlobalOrchestratorConfig($config: UpdateGlobalOrchestratorConfigInput!) {
  __typename
  updateGlobalOrchestratorConfig(config: $config) {
    __typename
    lastActiveTagKey
    dryRun
    logLevel
    region
    regions
    emaAlpha
    emaEnabled
    objectVersion
  }
}
    `);
export const CreateIdeOrchestratorConfigDocument = new TypedDocumentString(`
    mutation CreateIdeOrchestratorConfig($config: CreateIdeOrchestratorConfigInput!) {
  __typename
  createIdeOrchestratorConfig(config: $config) {
    __typename
    ideName
    minInstances
    maxInstances
    hibernationPoolSize
    idleThresholdSeconds
    messagesPerInstance
    maxMessageAgeSeconds
    urgencyExtraInstances
    enabled
    objectVersion
  }
}
    `);
export const UpdateIdeOrchestratorConfigDocument = new TypedDocumentString(`
    mutation UpdateIdeOrchestratorConfig($ideName: String!, $config: UpdateIdeOrchestratorConfigInput!) {
  __typename
  updateIdeOrchestratorConfig(ideName: $ideName, config: $config) {
    __typename
    ideName
    minInstances
    maxInstances
    hibernationPoolSize
    idleThresholdSeconds
    messagesPerInstance
    maxMessageAgeSeconds
    urgencyExtraInstances
    enabled
    objectVersion
  }
}
    `);
export const DeleteIdeOrchestratorConfigDocument = new TypedDocumentString(`
    mutation DeleteIdeOrchestratorConfig($ideName: String!) {
  __typename
  deleteIdeOrchestratorConfig(ideName: $ideName)
}
    `);
export const CreateIdeOrchestratorConfigOverrideDocument = new TypedDocumentString(`
    mutation CreateIdeOrchestratorConfigOverride($override: CreateIdeOrchestratorConfigOverrideInput!) {
  __typename
  createIdeOrchestratorConfigOverride(override: $override) {
    __typename
    ideName
    region
    minInstances
    maxInstances
    hibernationPoolSize
    objectVersion
  }
}
    `);
export const UpdateIdeOrchestratorConfigOverrideDocument = new TypedDocumentString(`
    mutation UpdateIdeOrchestratorConfigOverride($ideName: String!, $region: String!, $override: UpdateIdeOrchestratorConfigOverrideInput!) {
  __typename
  updateIdeOrchestratorConfigOverride(
    ideName: $ideName
    region: $region
    override: $override
  ) {
    __typename
    ideName
    region
    minInstances
    maxInstances
    hibernationPoolSize
    objectVersion
  }
}
    `);
export const DeleteIdeOrchestratorConfigOverrideDocument = new TypedDocumentString(`
    mutation DeleteIdeOrchestratorConfigOverride($ideName: String!, $region: String!) {
  __typename
  deleteIdeOrchestratorConfigOverride(ideName: $ideName, region: $region)
}
    `);
export const ReadTenantsForSuperTenantDocument = new TypedDocumentString(`
    query ReadTenantsForSuperTenant($filter: TenantFilterInput, $pagination: PaginationInput) {
  __typename
  readTenantsForSuperTenant(filter: $filter, pagination: $pagination) {
    __typename
    items {
      __typename
      ...BackofficeTenant
    }
    itemCount
    pages
  }
}
    fragment BackofficeUserInfo on LightUserResponseType {
  __typename
  userId
  firstName
  lastName
  email
  source
  isSystemUser
  termsAndConditions {
    __typename
    accepted
    acceptedTimestamp
    termsAndConditionsVersion
    latestTermsAndConditionsVersionAccepted
  }
}
fragment BackofficeTenant on TenantResponseType {
  __typename
  tenantId
  companyName
  owner {
    __typename
    ...BackofficeUserInfo
  }
  country
  ssoEnabled
  objectVersion
  creationTimestamp
  industry
  isActive
  groupId
  metaData
}`);
export const ReadTenantForSuperTenantDocument = new TypedDocumentString(`
    query ReadTenantForSuperTenant($tenantId: String!) {
  __typename
  readTenant(tenantId: $tenantId) {
    __typename
    ...BackofficeTenant
  }
}
    fragment BackofficeUserInfo on LightUserResponseType {
  __typename
  userId
  firstName
  lastName
  email
  source
  isSystemUser
  termsAndConditions {
    __typename
    accepted
    acceptedTimestamp
    termsAndConditionsVersion
    latestTermsAndConditionsVersionAccepted
  }
}
fragment BackofficeTenant on TenantResponseType {
  __typename
  tenantId
  companyName
  owner {
    __typename
    ...BackofficeUserInfo
  }
  country
  ssoEnabled
  objectVersion
  creationTimestamp
  industry
  isActive
  groupId
  metaData
}`);
export const ReadTenantFeatureFlagsDocument = new TypedDocumentString(`
    query ReadTenantFeatureFlags($tenantId: String!) {
  __typename
  readTenant(tenantId: $tenantId) {
    __typename
    tenantId
    objectVersion
    featureFlags {
      __typename
      ...FeatureFlagFragment
    }
  }
}
    fragment FeatureFlagFragment on FeatureFlagType {
  __typename
  featureName
  isEnabled
  description
}`);
export const ReadTenantForUpdateDocument = new TypedDocumentString(`
    query ReadTenantForUpdate($tenantId: String!) {
  __typename
  readTenant(tenantId: $tenantId) {
    __typename
    tenantId
    objectVersion
    ownerId
    groupId
    ssoEnabled
    metaData
    users {
      __typename
      items {
        __typename
        ...BackofficeUserInfo
      }
      itemCount
    }
  }
}
    fragment BackofficeUserInfo on LightUserResponseType {
  __typename
  userId
  firstName
  lastName
  email
  source
  isSystemUser
  termsAndConditions {
    __typename
    accepted
    acceptedTimestamp
    termsAndConditionsVersion
    latestTermsAndConditionsVersionAccepted
  }
}`);
export const ReadAllSuperUserRolesDocument = new TypedDocumentString(`
    query ReadAllSuperUserRoles($filter: SuperUserRoleFilterInput, $pagination: PaginationInput) {
  __typename
  readAllUserRoles: readAllSuperUserRoles(
    filter: $filter
    pagination: $pagination
  ) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...SuperUserRole
    }
  }
}
    fragment SuperUserPolicy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment BaseSuperUser on SuperUserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
}
fragment SuperUserRole on SuperUserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  users {
    __typename
    itemCount
    items {
      __typename
      ...BaseSuperUser
    }
  }
  policies {
    __typename
    ...SuperUserPolicy
  }
  groupId
}`);
export const ReadSuperUserRolesForSelectDocument = new TypedDocumentString(`
    query ReadSuperUserRolesForSelect($filter: SuperUserRoleFilterInput) {
  __typename
  readAllUserRoles: readAllSuperUserRoles(filter: $filter) {
    __typename
    items {
      __typename
      ...SuperUserRoleForSelect
    }
  }
}
    fragment SuperUserRoleForSelect on SuperUserRoleResponseType {
  __typename
  userRoleId
  name
  isSystemRole
  groupId
  objectVersion
}`);
export const ReadSuperUserRoleDocument = new TypedDocumentString(`
    query ReadSuperUserRole($userRoleId: String!) {
  __typename
  readUserRole: readSuperUserRole(userRoleId: $userRoleId) {
    __typename
    ...SuperUserRole
  }
}
    fragment SuperUserPolicy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment BaseSuperUser on SuperUserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
}
fragment SuperUserRole on SuperUserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  users {
    __typename
    itemCount
    items {
      __typename
      ...BaseSuperUser
    }
  }
  policies {
    __typename
    ...SuperUserPolicy
  }
  groupId
}`);
export const ReadSuperUserRolesForOwnUserDocument = new TypedDocumentString(`
    query ReadSuperUserRolesForOwnUser($pagination: PaginationInput) {
  __typename
  readSuperUserRolesForOwnUser(pagination: $pagination) {
    __typename
    items {
      __typename
      ...OwnSuperUserRole
    }
    itemCount
    pages
  }
}
    fragment SuperUserPolicy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment OwnSuperUserRole on SuperUserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  policies {
    __typename
    ...SuperUserPolicy
  }
  groupId
}`);
export const ReadAllSuperUsersDocument = new TypedDocumentString(`
    query ReadAllSuperUsers($filter: SuperUserFilterInput, $pagination: PaginationInput) {
  __typename
  readAllUsers: readAllSuperUsers(filter: $filter, pagination: $pagination) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...SuperUser
    }
  }
}
    fragment SuperUserPolicy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment BaseSuperUser on SuperUserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
}
fragment SuperUser on SuperUserResponseType {
  __typename
  ...BaseSuperUser
  userRoles {
    __typename
    items {
      __typename
      ...OwnSuperUserRole
    }
    pages
    itemCount
  }
}
fragment OwnSuperUserRole on SuperUserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  policies {
    __typename
    ...SuperUserPolicy
  }
  groupId
}`);
export const ReadSuperUsersForSelectDocument = new TypedDocumentString(`
    query ReadSuperUsersForSelect($filter: SuperUserFilterInput) {
  __typename
  readAllUsers: readAllSuperUsers(filter: $filter) {
    __typename
    items {
      __typename
      ...SuperUserForSelect
    }
  }
}
    fragment SuperUserForSelect on SuperUserResponseType {
  __typename
  userId
  firstName
  lastName
  email
  source
  groupId
  objectVersion
  userRoles {
    __typename
    items {
      __typename
      isSystemRole
    }
  }
}`);
export const ReadSuperUserDocument = new TypedDocumentString(`
    query ReadSuperUser($userId: String!) {
  __typename
  readUser: readSuperUser(userId: $userId) {
    __typename
    ...SuperUser
  }
}
    fragment SuperUserPolicy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment BaseSuperUser on SuperUserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
}
fragment SuperUser on SuperUserResponseType {
  __typename
  ...BaseSuperUser
  userRoles {
    __typename
    items {
      __typename
      ...OwnSuperUserRole
    }
    pages
    itemCount
  }
}
fragment OwnSuperUserRole on SuperUserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  policies {
    __typename
    ...SuperUserPolicy
  }
  groupId
}`);
export const ReadSuperUsersForUserRoleDocument = new TypedDocumentString(`
    query ReadSuperUsersForUserRole($userRoleId: String!, $pagination: PaginationInput) {
  __typename
  readUsersForUserRole: readSuperUsersForUserRole(
    userRoleId: $userRoleId
    pagination: $pagination
  ) {
    __typename
    items {
      __typename
      ...SuperUser
    }
    itemCount
    pages
  }
}
    fragment SuperUserPolicy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment BaseSuperUser on SuperUserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
}
fragment SuperUser on SuperUserResponseType {
  __typename
  ...BaseSuperUser
  userRoles {
    __typename
    items {
      __typename
      ...OwnSuperUserRole
    }
    pages
    itemCount
  }
}
fragment OwnSuperUserRole on SuperUserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  policies {
    __typename
    ...SuperUserPolicy
  }
  groupId
}`);
export const ReadSuperUserRoleUserLinksForUserDocument = new TypedDocumentString(`
    query ReadSuperUserRoleUserLinksForUser($userId: String!) {
  __typename
  readUserRoleUserLinksForUser: readSuperUserRoleUserLinksForUser(userId: $userId) {
    __typename
    items {
      __typename
      ...SuperUserRoleLink
    }
    itemCount
    pages
  }
}
    fragment SuperUserRoleLink on SuperUserRoleUserLinkResponseType {
  __typename
  expirationTimestamp
  userId
  userRoleId
  objectVersion
}`);
export const ReadSuperUserRoleUserLinksForUserRoleDocument = new TypedDocumentString(`
    query ReadSuperUserRoleUserLinksForUserRole($userRoleId: String!) {
  __typename
  readUserRoleUserLinksForUserRole: readSuperUserRoleUserLinksForUserRole(
    userRoleId: $userRoleId
  ) {
    __typename
    items {
      __typename
      ...SuperUserRoleLink
    }
    itemCount
    pages
  }
}
    fragment SuperUserRoleLink on SuperUserRoleUserLinkResponseType {
  __typename
  expirationTimestamp
  userId
  userRoleId
  objectVersion
}`);
export const ReadSuperTenantDocument = new TypedDocumentString(`
    query ReadSuperTenant {
  __typename
  readSuperTenant {
    __typename
    superTenantId
    identifier
    companyName
    featureFlags {
      __typename
      ...FeatureFlagFragment
    }
  }
}
    fragment FeatureFlagFragment on FeatureFlagType {
  __typename
  featureName
  isEnabled
  description
}`);
export const ReadBackofficeResourceGroupByIdDocument = new TypedDocumentString(`
    query ReadBackofficeResourceGroupById($groupId: String!) {
  __typename
  readResourceGroup: readBackofficeResourceGroup(groupId: $groupId) {
    __typename
    ...BackofficeResourceGroup
  }
  readSubGroupsForResourceGroup: readSubGroupsForBackofficeResourceGroup(
    parentGroupId: $groupId
  ) {
    __typename
    items {
      __typename
      ...BackofficeResourceGroup
    }
    pages
    itemCount
  }
}
    fragment BackofficeResourceGroupUserInfo on LightSuperUserResponseType {
  __typename
  firstName
  lastName
  email
  source
}
fragment BackofficeSubGroup on BackofficeResourceGroupResponseType {
  __typename
  name
  groupId
  creationTimestamp
  updateTimestamp
  fullPaths
}
fragment BackofficeResourceGroup on BackofficeResourceGroupResponseType {
  __typename
  updateUser {
    __typename
    ...BackofficeResourceGroupUserInfo
  }
  creationUser {
    __typename
    ...BackofficeResourceGroupUserInfo
  }
  updateTimestamp
  creationTimestamp
  name
  parentGroupId
  groupId
  objectVersion
  groupType
  isSystemGroup
  subGroups {
    __typename
    itemCount
    items {
      __typename
      ...BackofficeSubGroup
    }
    pages
  }
  fullPaths
}`);
export const ReadBackofficeResourceGroupsToBuildTreeDocument = new TypedDocumentString(`
    query ReadBackofficeResourceGroupsToBuildTree($filter: BackofficeResourceGroupFilterInput) {
  __typename
  readAllResourceGroups: readAllBackofficeResourceGroups(filter: $filter) {
    __typename
    items {
      __typename
      ...BackofficeGroupTreeItem
    }
    itemCount
  }
}
    fragment BackofficeGroupTreeItem on BackofficeResourceGroupResponseType {
  __typename
  groupId
  name
  parentGroupId
  creationTimestamp
  updateTimestamp
  objectVersion
  fullPaths
}`);
export const ReadAllBackofficeResourceGroupsDocument = new TypedDocumentString(`
    query ReadAllBackofficeResourceGroups($filter: BackofficeResourceGroupFilterInput, $pagination: PaginationInput) {
  __typename
  readAllResourceGroups: readAllBackofficeResourceGroups(
    filter: $filter
    pagination: $pagination
  ) {
    __typename
    items {
      __typename
      ...BackofficeResourceGroup
    }
    itemCount
    pages
  }
}
    fragment BackofficeResourceGroupUserInfo on LightSuperUserResponseType {
  __typename
  firstName
  lastName
  email
  source
}
fragment BackofficeSubGroup on BackofficeResourceGroupResponseType {
  __typename
  name
  groupId
  creationTimestamp
  updateTimestamp
  fullPaths
}
fragment BackofficeResourceGroup on BackofficeResourceGroupResponseType {
  __typename
  updateUser {
    __typename
    ...BackofficeResourceGroupUserInfo
  }
  creationUser {
    __typename
    ...BackofficeResourceGroupUserInfo
  }
  updateTimestamp
  creationTimestamp
  name
  parentGroupId
  groupId
  objectVersion
  groupType
  isSystemGroup
  subGroups {
    __typename
    itemCount
    items {
      __typename
      ...BackofficeSubGroup
    }
    pages
  }
  fullPaths
}`);
export const ReadBackofficeResourceGroupsForSelectDocument = new TypedDocumentString(`
    query ReadBackofficeResourceGroupsForSelect($filter: BackofficeResourceGroupFilterInput) {
  __typename
  readAllResourceGroups: readAllBackofficeResourceGroups(filter: $filter) {
    __typename
    items {
      __typename
      ...BackofficeResourceGroupForSelect
    }
  }
}
    fragment BackofficeResourceGroupForSelect on BackofficeResourceGroupResponseType {
  __typename
  groupId
  parentGroupId
  name
  fullPaths
}`);
export const ReadSubGroupsForBackofficeResourceGroupDocument = new TypedDocumentString(`
    query ReadSubGroupsForBackofficeResourceGroup($groupId: String!, $pagination: PaginationInput) {
  __typename
  readSubGroupsForResourceGroup: readSubGroupsForBackofficeResourceGroup(
    parentGroupId: $groupId
    pagination: $pagination
  ) {
    __typename
    items {
      __typename
      ...BackofficeResourceGroup
    }
    pages
    itemCount
  }
}
    fragment BackofficeResourceGroupUserInfo on LightSuperUserResponseType {
  __typename
  firstName
  lastName
  email
  source
}
fragment BackofficeSubGroup on BackofficeResourceGroupResponseType {
  __typename
  name
  groupId
  creationTimestamp
  updateTimestamp
  fullPaths
}
fragment BackofficeResourceGroup on BackofficeResourceGroupResponseType {
  __typename
  updateUser {
    __typename
    ...BackofficeResourceGroupUserInfo
  }
  creationUser {
    __typename
    ...BackofficeResourceGroupUserInfo
  }
  updateTimestamp
  creationTimestamp
  name
  parentGroupId
  groupId
  objectVersion
  groupType
  isSystemGroup
  subGroups {
    __typename
    itemCount
    items {
      __typename
      ...BackofficeSubGroup
    }
    pages
  }
  fullPaths
}`);
export const ReadBackofficeResourceGroupNamesForRoleRowDocument = new TypedDocumentString(`
    query ReadBackofficeResourceGroupNamesForRoleRow($groupIds: [String!]!) {
  __typename
  readResourceGroupsByIds: readBackofficeResourceGroupsByIds(groupIds: $groupIds) {
    __typename
    items {
      __typename
      name
      groupId
      parentGroupId
    }
  }
}
    `);
export const ReadBackofficeResourceGroupNameByIdDocument = new TypedDocumentString(`
    query ReadBackofficeResourceGroupNameById($groupId: String!) {
  __typename
  readResourceGroup: readBackofficeResourceGroup(groupId: $groupId) {
    __typename
    name
    parentGroupId
    fullPaths
  }
}
    `);
export const ReadBackofficeGroupResourceCountsDocument = new TypedDocumentString(`
    query ReadBackofficeGroupResourceCounts($groupId: String!) {
  __typename
  readBackofficeResourceGroup(groupId: $groupId) {
    __typename
    groupId
    subGroups {
      __typename
      itemCount
    }
    tenants {
      __typename
      itemCount
    }
  }
  groupUsers: readAllSuperUsers(filter: {groupId: {eq: $groupId}}) {
    __typename
    itemCount
  }
  groupRoles: readAllSuperUserRoles(filter: {groupId: {eq: $groupId}}) {
    __typename
    itemCount
  }
}
    `);
export const ReadBackofficeUngroupedResourceCountsDocument = new TypedDocumentString(`
    query ReadBackofficeUngroupedResourceCounts {
  __typename
  groupUsers: readAllSuperUsers(filter: {groupId: {doNotIgnoreNullable: [eq]}}) {
    __typename
    itemCount
  }
  groupRoles: readAllSuperUserRoles(
    filter: {groupId: {doNotIgnoreNullable: [eq]}}
  ) {
    __typename
    itemCount
  }
  groupTenants: readTenantsForSuperTenant(
    filter: {groupId: {doNotIgnoreNullable: [eq]}}
  ) {
    __typename
    itemCount
  }
}
    `);
export const ReadSuperUserUiPreferencesDocument = new TypedDocumentString(`
    query ReadSuperUserUiPreferences {
  __typename
  readUserUiPreferences: readSuperUserUiPreferences {
    __typename
    uiPreferences
    objectVersion
  }
}
    `);
export const ReadGlobalOrchestratorConfigDocument = new TypedDocumentString(`
    query ReadGlobalOrchestratorConfig {
  __typename
  readGlobalOrchestratorConfig {
    __typename
    lastActiveTagKey
    dryRun
    logLevel
    region
    regions
    emaAlpha
    emaEnabled
    objectVersion
  }
}
    `);
export const ListIdeOrchestratorConfigsDocument = new TypedDocumentString(`
    query ListIdeOrchestratorConfigs {
  __typename
  listIdeOrchestratorConfigs {
    __typename
    ideName
    minInstances
    maxInstances
    hibernationPoolSize
    idleThresholdSeconds
    messagesPerInstance
    maxMessageAgeSeconds
    urgencyExtraInstances
    enabled
    objectVersion
  }
}
    `);
export const ListAllIdeOrchestratorConfigOverridesDocument = new TypedDocumentString(`
    query ListAllIdeOrchestratorConfigOverrides {
  __typename
  listAllIdeOrchestratorConfigOverrides {
    __typename
    ideName
    region
    minInstances
    maxInstances
    hibernationPoolSize
    objectVersion
  }
}
    `);
export const ListConfigChangeHistoryDocument = new TypedDocumentString(`
    query ListConfigChangeHistory($scope: ConfigChangeScopeInput, $startTime: DateTime, $endTime: DateTime, $pagination: PaginationInput) {
  __typename
  listConfigChangeHistory(
    scope: $scope
    startTime: $startTime
    endTime: $endTime
    pagination: $pagination
  ) {
    __typename
    pages
    itemCount
    items {
      __typename
      changeId
      scopeType
      ideName
      region
      operation
      oldConfig
      newConfig
      changedBy
      changedAt
      status
      appliedAt
      appliedRunId
    }
  }
}
    `);
export const FleetCapacityMetricsDocument = new TypedDocumentString(`
    query FleetCapacityMetrics($startTime: DateTime!, $endTime: DateTime!, $periodSeconds: Int, $ideName: String, $region: String) {
  __typename
  fleetCapacityMetrics(
    startTime: $startTime
    endTime: $endTime
    periodSeconds: $periodSeconds
    ideName: $ideName
    region: $region
  ) {
    __typename
    series {
      __typename
      name
      unit
      source
      points {
        __typename
        timestamp
        value
      }
    }
  }
}
    `);
export const ReadSuperUserNamesDocument = new TypedDocumentString(`
    query ReadSuperUserNames($pagination: PaginationInput) {
  __typename
  readSuperUserNames: readAllSuperUsers(pagination: $pagination) {
    __typename
    itemCount
    items {
      __typename
      userId
      firstName
      lastName
      email
    }
  }
}
    `);
export const ReadOrchestratorRunStatusDocument = new TypedDocumentString(`
    query ReadOrchestratorRunStatus($pagination: PaginationInput) {
  __typename
  readOrchestratorRunStatus(pagination: $pagination) {
    __typename
    items {
      __typename
      startedAt
      requestId
      triggerType
      durationMs
      asgsTotal
      asgsOk
      asgsError
      asgsSkipped
      dryRun
      results
    }
    pages
    itemCount
    lastRunAgeSeconds
    isStale
    expectedIntervalSeconds
  }
}
    `);
export const ReadUiSpeedSummaryDocument = new TypedDocumentString(`
    query ReadUiSpeedSummary {
  __typename
  readUiSpeedSummary {
    __typename
    summary
  }
}
    `);
export const ReadSreHubSummaryDocument = new TypedDocumentString(`
    query ReadSreHubSummary($indicator: SreHubIndicator!) {
  __typename
  readSreHubSummary(indicator: $indicator) {
    __typename
    summary
  }
}
    `);
export const ReadSuperTenantFeatureFlagCatalogsDocument = new TypedDocumentString(`
    query ReadSuperTenantFeatureFlagCatalogs {
  __typename
  readAllSuperTenants {
    __typename
    superTenantId
    identifier
    featureFlags {
      __typename
      featureName
      description
      isPublished: isEnabled
    }
  }
}
    `);

const injectedRtkApi = baseBackofficeApi.injectEndpoints({
  overrideExisting: isHotReloadEnabled && module.hot?.status() === "apply",
  endpoints: (build) => ({
    LoginTenantForSuperTenant: build.mutation<Types.LoginTenantForSuperTenantMutation, Types.LoginTenantForSuperTenantMutationVariables>({
      query: (variables) => ({ document: LoginTenantForSuperTenantDocument as unknown as string, variables })
    }),
    ActivateTenant: build.mutation<Types.ActivateTenantMutation, Types.ActivateTenantMutationVariables>({
      query: (variables) => ({ document: ActivateTenantDocument as unknown as string, variables })
    }),
    UpdateBackofficeTenant: build.mutation<Types.UpdateBackofficeTenantMutation, Types.UpdateBackofficeTenantMutationVariables>({
      query: (variables) => ({ document: UpdateBackofficeTenantDocument as unknown as string, variables })
    }),
    UpdateTenantSecuritySettings: build.mutation<Types.UpdateTenantSecuritySettingsMutation, Types.UpdateTenantSecuritySettingsMutationVariables>({
      query: (variables) => ({ document: UpdateTenantSecuritySettingsDocument as unknown as string, variables })
    }),
    CreateSuperUser: build.mutation<Types.CreateSuperUserMutation, Types.CreateSuperUserMutationVariables>({
      query: (variables) => ({ document: CreateSuperUserDocument as unknown as string, variables })
    }),
    UpdateSuperUser: build.mutation<Types.UpdateSuperUserMutation, Types.UpdateSuperUserMutationVariables>({
      query: (variables) => ({ document: UpdateSuperUserDocument as unknown as string, variables })
    }),
    DeleteSuperUser: build.mutation<Types.DeleteSuperUserMutation, Types.DeleteSuperUserMutationVariables>({
      query: (variables) => ({ document: DeleteSuperUserDocument as unknown as string, variables })
    }),
    CreateSuperUserRole: build.mutation<Types.CreateSuperUserRoleMutation, Types.CreateSuperUserRoleMutationVariables>({
      query: (variables) => ({ document: CreateSuperUserRoleDocument as unknown as string, variables })
    }),
    UpdateSuperUserRole: build.mutation<Types.UpdateSuperUserRoleMutation, Types.UpdateSuperUserRoleMutationVariables>({
      query: (variables) => ({ document: UpdateSuperUserRoleDocument as unknown as string, variables })
    }),
    DeleteSuperUserRole: build.mutation<Types.DeleteSuperUserRoleMutation, Types.DeleteSuperUserRoleMutationVariables>({
      query: (variables) => ({ document: DeleteSuperUserRoleDocument as unknown as string, variables })
    }),
    CreateSuperUserRoleUserLink: build.mutation<Types.CreateSuperUserRoleUserLinkMutation, Types.CreateSuperUserRoleUserLinkMutationVariables>({
      query: (variables) => ({ document: CreateSuperUserRoleUserLinkDocument as unknown as string, variables })
    }),
    DeleteSuperUserRoleUserLink: build.mutation<Types.DeleteSuperUserRoleUserLinkMutation, Types.DeleteSuperUserRoleUserLinkMutationVariables>({
      query: (variables) => ({ document: DeleteSuperUserRoleUserLinkDocument as unknown as string, variables })
    }),
    UpdateSuperUserRoleUserLink: build.mutation<Types.UpdateSuperUserRoleUserLinkMutation, Types.UpdateSuperUserRoleUserLinkMutationVariables>({
      query: (variables) => ({ document: UpdateSuperUserRoleUserLinkDocument as unknown as string, variables })
    }),
    CreateBackofficeResourceGroup: build.mutation<Types.CreateBackofficeResourceGroupMutation, Types.CreateBackofficeResourceGroupMutationVariables>({
      query: (variables) => ({ document: CreateBackofficeResourceGroupDocument as unknown as string, variables })
    }),
    UpdateBackofficeResourceGroup: build.mutation<Types.UpdateBackofficeResourceGroupMutation, Types.UpdateBackofficeResourceGroupMutationVariables>({
      query: (variables) => ({ document: UpdateBackofficeResourceGroupDocument as unknown as string, variables })
    }),
    DeleteBackofficeResourceGroup: build.mutation<Types.DeleteBackofficeResourceGroupMutation, Types.DeleteBackofficeResourceGroupMutationVariables>({
      query: (variables) => ({ document: DeleteBackofficeResourceGroupDocument as unknown as string, variables })
    }),
    UpdateSuperUserUiPreferences: build.mutation<Types.UpdateSuperUserUiPreferencesMutation, Types.UpdateSuperUserUiPreferencesMutationVariables | void>({
      query: (variables) => ({ document: UpdateSuperUserUiPreferencesDocument as unknown as string, variables })
    }),
    CreateSuperTenantFeatureFlag: build.mutation<Types.CreateSuperTenantFeatureFlagMutation, Types.CreateSuperTenantFeatureFlagMutationVariables>({
      query: (variables) => ({ document: CreateSuperTenantFeatureFlagDocument as unknown as string, variables })
    }),
    UpdateSuperTenantFeatureFlag: build.mutation<Types.UpdateSuperTenantFeatureFlagMutation, Types.UpdateSuperTenantFeatureFlagMutationVariables>({
      query: (variables) => ({ document: UpdateSuperTenantFeatureFlagDocument as unknown as string, variables })
    }),
    DeleteSuperTenantFeatureFlag: build.mutation<Types.DeleteSuperTenantFeatureFlagMutation, Types.DeleteSuperTenantFeatureFlagMutationVariables>({
      query: (variables) => ({ document: DeleteSuperTenantFeatureFlagDocument as unknown as string, variables })
    }),
    UpdateGlobalOrchestratorConfig: build.mutation<Types.UpdateGlobalOrchestratorConfigMutation, Types.UpdateGlobalOrchestratorConfigMutationVariables>({
      query: (variables) => ({ document: UpdateGlobalOrchestratorConfigDocument as unknown as string, variables })
    }),
    CreateIdeOrchestratorConfig: build.mutation<Types.CreateIdeOrchestratorConfigMutation, Types.CreateIdeOrchestratorConfigMutationVariables>({
      query: (variables) => ({ document: CreateIdeOrchestratorConfigDocument as unknown as string, variables })
    }),
    UpdateIdeOrchestratorConfig: build.mutation<Types.UpdateIdeOrchestratorConfigMutation, Types.UpdateIdeOrchestratorConfigMutationVariables>({
      query: (variables) => ({ document: UpdateIdeOrchestratorConfigDocument as unknown as string, variables })
    }),
    DeleteIdeOrchestratorConfig: build.mutation<Types.DeleteIdeOrchestratorConfigMutation, Types.DeleteIdeOrchestratorConfigMutationVariables>({
      query: (variables) => ({ document: DeleteIdeOrchestratorConfigDocument as unknown as string, variables })
    }),
    CreateIdeOrchestratorConfigOverride: build.mutation<Types.CreateIdeOrchestratorConfigOverrideMutation, Types.CreateIdeOrchestratorConfigOverrideMutationVariables>({
      query: (variables) => ({ document: CreateIdeOrchestratorConfigOverrideDocument as unknown as string, variables })
    }),
    UpdateIdeOrchestratorConfigOverride: build.mutation<Types.UpdateIdeOrchestratorConfigOverrideMutation, Types.UpdateIdeOrchestratorConfigOverrideMutationVariables>({
      query: (variables) => ({ document: UpdateIdeOrchestratorConfigOverrideDocument as unknown as string, variables })
    }),
    DeleteIdeOrchestratorConfigOverride: build.mutation<Types.DeleteIdeOrchestratorConfigOverrideMutation, Types.DeleteIdeOrchestratorConfigOverrideMutationVariables>({
      query: (variables) => ({ document: DeleteIdeOrchestratorConfigOverrideDocument as unknown as string, variables })
    }),
    ReadTenantsForSuperTenant: build.query<Types.ReadTenantsForSuperTenantQuery, Types.ReadTenantsForSuperTenantQueryVariables | void>({
      query: (variables) => ({ document: ReadTenantsForSuperTenantDocument as unknown as string, variables })
    }),
    ReadTenantForSuperTenant: build.query<Types.ReadTenantForSuperTenantQuery, Types.ReadTenantForSuperTenantQueryVariables>({
      query: (variables) => ({ document: ReadTenantForSuperTenantDocument as unknown as string, variables })
    }),
    ReadTenantFeatureFlags: build.query<Types.ReadTenantFeatureFlagsQuery, Types.ReadTenantFeatureFlagsQueryVariables>({
      query: (variables) => ({ document: ReadTenantFeatureFlagsDocument as unknown as string, variables })
    }),
    ReadTenantForUpdate: build.query<Types.ReadTenantForUpdateQuery, Types.ReadTenantForUpdateQueryVariables>({
      query: (variables) => ({ document: ReadTenantForUpdateDocument as unknown as string, variables })
    }),
    ReadAllSuperUserRoles: build.query<Types.ReadAllSuperUserRolesQuery, Types.ReadAllSuperUserRolesQueryVariables | void>({
      query: (variables) => ({ document: ReadAllSuperUserRolesDocument as unknown as string, variables })
    }),
    ReadSuperUserRolesForSelect: build.query<Types.ReadSuperUserRolesForSelectQuery, Types.ReadSuperUserRolesForSelectQueryVariables | void>({
      query: (variables) => ({ document: ReadSuperUserRolesForSelectDocument as unknown as string, variables })
    }),
    ReadSuperUserRole: build.query<Types.ReadSuperUserRoleQuery, Types.ReadSuperUserRoleQueryVariables>({
      query: (variables) => ({ document: ReadSuperUserRoleDocument as unknown as string, variables })
    }),
    ReadSuperUserRolesForOwnUser: build.query<Types.ReadSuperUserRolesForOwnUserQuery, Types.ReadSuperUserRolesForOwnUserQueryVariables | void>({
      query: (variables) => ({ document: ReadSuperUserRolesForOwnUserDocument as unknown as string, variables })
    }),
    ReadAllSuperUsers: build.query<Types.ReadAllSuperUsersQuery, Types.ReadAllSuperUsersQueryVariables | void>({
      query: (variables) => ({ document: ReadAllSuperUsersDocument as unknown as string, variables })
    }),
    ReadSuperUsersForSelect: build.query<Types.ReadSuperUsersForSelectQuery, Types.ReadSuperUsersForSelectQueryVariables | void>({
      query: (variables) => ({ document: ReadSuperUsersForSelectDocument as unknown as string, variables })
    }),
    ReadSuperUser: build.query<Types.ReadSuperUserQuery, Types.ReadSuperUserQueryVariables>({
      query: (variables) => ({ document: ReadSuperUserDocument as unknown as string, variables })
    }),
    ReadSuperUsersForUserRole: build.query<Types.ReadSuperUsersForUserRoleQuery, Types.ReadSuperUsersForUserRoleQueryVariables>({
      query: (variables) => ({ document: ReadSuperUsersForUserRoleDocument as unknown as string, variables })
    }),
    ReadSuperUserRoleUserLinksForUser: build.query<Types.ReadSuperUserRoleUserLinksForUserQuery, Types.ReadSuperUserRoleUserLinksForUserQueryVariables>({
      query: (variables) => ({ document: ReadSuperUserRoleUserLinksForUserDocument as unknown as string, variables })
    }),
    ReadSuperUserRoleUserLinksForUserRole: build.query<Types.ReadSuperUserRoleUserLinksForUserRoleQuery, Types.ReadSuperUserRoleUserLinksForUserRoleQueryVariables>({
      query: (variables) => ({ document: ReadSuperUserRoleUserLinksForUserRoleDocument as unknown as string, variables })
    }),
    ReadSuperTenant: build.query<Types.ReadSuperTenantQuery, Types.ReadSuperTenantQueryVariables | void>({
      query: (variables) => ({ document: ReadSuperTenantDocument as unknown as string, variables })
    }),
    ReadBackofficeResourceGroupById: build.query<Types.ReadBackofficeResourceGroupByIdQuery, Types.ReadBackofficeResourceGroupByIdQueryVariables>({
      query: (variables) => ({ document: ReadBackofficeResourceGroupByIdDocument as unknown as string, variables })
    }),
    ReadBackofficeResourceGroupsToBuildTree: build.query<Types.ReadBackofficeResourceGroupsToBuildTreeQuery, Types.ReadBackofficeResourceGroupsToBuildTreeQueryVariables | void>({
      query: (variables) => ({ document: ReadBackofficeResourceGroupsToBuildTreeDocument as unknown as string, variables })
    }),
    ReadAllBackofficeResourceGroups: build.query<Types.ReadAllBackofficeResourceGroupsQuery, Types.ReadAllBackofficeResourceGroupsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllBackofficeResourceGroupsDocument as unknown as string, variables })
    }),
    ReadBackofficeResourceGroupsForSelect: build.query<Types.ReadBackofficeResourceGroupsForSelectQuery, Types.ReadBackofficeResourceGroupsForSelectQueryVariables | void>({
      query: (variables) => ({ document: ReadBackofficeResourceGroupsForSelectDocument as unknown as string, variables })
    }),
    ReadSubGroupsForBackofficeResourceGroup: build.query<Types.ReadSubGroupsForBackofficeResourceGroupQuery, Types.ReadSubGroupsForBackofficeResourceGroupQueryVariables>({
      query: (variables) => ({ document: ReadSubGroupsForBackofficeResourceGroupDocument as unknown as string, variables })
    }),
    ReadBackofficeResourceGroupNamesForRoleRow: build.query<Types.ReadBackofficeResourceGroupNamesForRoleRowQuery, Types.ReadBackofficeResourceGroupNamesForRoleRowQueryVariables>({
      query: (variables) => ({ document: ReadBackofficeResourceGroupNamesForRoleRowDocument as unknown as string, variables })
    }),
    ReadBackofficeResourceGroupNameById: build.query<Types.ReadBackofficeResourceGroupNameByIdQuery, Types.ReadBackofficeResourceGroupNameByIdQueryVariables>({
      query: (variables) => ({ document: ReadBackofficeResourceGroupNameByIdDocument as unknown as string, variables })
    }),
    ReadBackofficeGroupResourceCounts: build.query<Types.ReadBackofficeGroupResourceCountsQuery, Types.ReadBackofficeGroupResourceCountsQueryVariables>({
      query: (variables) => ({ document: ReadBackofficeGroupResourceCountsDocument as unknown as string, variables })
    }),
    ReadBackofficeUngroupedResourceCounts: build.query<Types.ReadBackofficeUngroupedResourceCountsQuery, Types.ReadBackofficeUngroupedResourceCountsQueryVariables | void>({
      query: (variables) => ({ document: ReadBackofficeUngroupedResourceCountsDocument as unknown as string, variables })
    }),
    ReadSuperUserUiPreferences: build.query<Types.ReadSuperUserUiPreferencesQuery, Types.ReadSuperUserUiPreferencesQueryVariables | void>({
      query: (variables) => ({ document: ReadSuperUserUiPreferencesDocument as unknown as string, variables })
    }),
    ReadGlobalOrchestratorConfig: build.query<Types.ReadGlobalOrchestratorConfigQuery, Types.ReadGlobalOrchestratorConfigQueryVariables | void>({
      query: (variables) => ({ document: ReadGlobalOrchestratorConfigDocument as unknown as string, variables })
    }),
    ListIdeOrchestratorConfigs: build.query<Types.ListIdeOrchestratorConfigsQuery, Types.ListIdeOrchestratorConfigsQueryVariables | void>({
      query: (variables) => ({ document: ListIdeOrchestratorConfigsDocument as unknown as string, variables })
    }),
    ListAllIdeOrchestratorConfigOverrides: build.query<Types.ListAllIdeOrchestratorConfigOverridesQuery, Types.ListAllIdeOrchestratorConfigOverridesQueryVariables | void>({
      query: (variables) => ({ document: ListAllIdeOrchestratorConfigOverridesDocument as unknown as string, variables })
    }),
    ListConfigChangeHistory: build.query<Types.ListConfigChangeHistoryQuery, Types.ListConfigChangeHistoryQueryVariables | void>({
      query: (variables) => ({ document: ListConfigChangeHistoryDocument as unknown as string, variables })
    }),
    FleetCapacityMetrics: build.query<Types.FleetCapacityMetricsQuery, Types.FleetCapacityMetricsQueryVariables>({
      query: (variables) => ({ document: FleetCapacityMetricsDocument as unknown as string, variables })
    }),
    ReadSuperUserNames: build.query<Types.ReadSuperUserNamesQuery, Types.ReadSuperUserNamesQueryVariables | void>({
      query: (variables) => ({ document: ReadSuperUserNamesDocument as unknown as string, variables })
    }),
    ReadOrchestratorRunStatus: build.query<Types.ReadOrchestratorRunStatusQuery, Types.ReadOrchestratorRunStatusQueryVariables | void>({
      query: (variables) => ({ document: ReadOrchestratorRunStatusDocument as unknown as string, variables })
    }),
    ReadUiSpeedSummary: build.query<Types.ReadUiSpeedSummaryQuery, Types.ReadUiSpeedSummaryQueryVariables | void>({
      query: (variables) => ({ document: ReadUiSpeedSummaryDocument as unknown as string, variables })
    }),
    ReadSreHubSummary: build.query<Types.ReadSreHubSummaryQuery, Types.ReadSreHubSummaryQueryVariables>({
      query: (variables) => ({ document: ReadSreHubSummaryDocument as unknown as string, variables })
    }),
    ReadSuperTenantFeatureFlagCatalogs: build.query<Types.ReadSuperTenantFeatureFlagCatalogsQuery, Types.ReadSuperTenantFeatureFlagCatalogsQueryVariables | void>({
      query: (variables) => ({ document: ReadSuperTenantFeatureFlagCatalogsDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useLoginTenantForSuperTenantMutation, useActivateTenantMutation, useUpdateBackofficeTenantMutation, useUpdateTenantSecuritySettingsMutation, useCreateSuperUserMutation, useUpdateSuperUserMutation, useDeleteSuperUserMutation, useCreateSuperUserRoleMutation, useUpdateSuperUserRoleMutation, useDeleteSuperUserRoleMutation, useCreateSuperUserRoleUserLinkMutation, useDeleteSuperUserRoleUserLinkMutation, useUpdateSuperUserRoleUserLinkMutation, useCreateBackofficeResourceGroupMutation, useUpdateBackofficeResourceGroupMutation, useDeleteBackofficeResourceGroupMutation, useUpdateSuperUserUiPreferencesMutation, useCreateSuperTenantFeatureFlagMutation, useUpdateSuperTenantFeatureFlagMutation, useDeleteSuperTenantFeatureFlagMutation, useUpdateGlobalOrchestratorConfigMutation, useCreateIdeOrchestratorConfigMutation, useUpdateIdeOrchestratorConfigMutation, useDeleteIdeOrchestratorConfigMutation, useCreateIdeOrchestratorConfigOverrideMutation, useUpdateIdeOrchestratorConfigOverrideMutation, useDeleteIdeOrchestratorConfigOverrideMutation, useReadTenantsForSuperTenantQuery, useLazyReadTenantsForSuperTenantQuery, useReadTenantForSuperTenantQuery, useLazyReadTenantForSuperTenantQuery, useReadTenantFeatureFlagsQuery, useLazyReadTenantFeatureFlagsQuery, useReadTenantForUpdateQuery, useLazyReadTenantForUpdateQuery, useReadAllSuperUserRolesQuery, useLazyReadAllSuperUserRolesQuery, useReadSuperUserRolesForSelectQuery, useLazyReadSuperUserRolesForSelectQuery, useReadSuperUserRoleQuery, useLazyReadSuperUserRoleQuery, useReadSuperUserRolesForOwnUserQuery, useLazyReadSuperUserRolesForOwnUserQuery, useReadAllSuperUsersQuery, useLazyReadAllSuperUsersQuery, useReadSuperUsersForSelectQuery, useLazyReadSuperUsersForSelectQuery, useReadSuperUserQuery, useLazyReadSuperUserQuery, useReadSuperUsersForUserRoleQuery, useLazyReadSuperUsersForUserRoleQuery, useReadSuperUserRoleUserLinksForUserQuery, useLazyReadSuperUserRoleUserLinksForUserQuery, useReadSuperUserRoleUserLinksForUserRoleQuery, useLazyReadSuperUserRoleUserLinksForUserRoleQuery, useReadSuperTenantQuery, useLazyReadSuperTenantQuery, useReadBackofficeResourceGroupByIdQuery, useLazyReadBackofficeResourceGroupByIdQuery, useReadBackofficeResourceGroupsToBuildTreeQuery, useLazyReadBackofficeResourceGroupsToBuildTreeQuery, useReadAllBackofficeResourceGroupsQuery, useLazyReadAllBackofficeResourceGroupsQuery, useReadBackofficeResourceGroupsForSelectQuery, useLazyReadBackofficeResourceGroupsForSelectQuery, useReadSubGroupsForBackofficeResourceGroupQuery, useLazyReadSubGroupsForBackofficeResourceGroupQuery, useReadBackofficeResourceGroupNamesForRoleRowQuery, useLazyReadBackofficeResourceGroupNamesForRoleRowQuery, useReadBackofficeResourceGroupNameByIdQuery, useLazyReadBackofficeResourceGroupNameByIdQuery, useReadBackofficeGroupResourceCountsQuery, useLazyReadBackofficeGroupResourceCountsQuery, useReadBackofficeUngroupedResourceCountsQuery, useLazyReadBackofficeUngroupedResourceCountsQuery, useReadSuperUserUiPreferencesQuery, useLazyReadSuperUserUiPreferencesQuery, useReadGlobalOrchestratorConfigQuery, useLazyReadGlobalOrchestratorConfigQuery, useListIdeOrchestratorConfigsQuery, useLazyListIdeOrchestratorConfigsQuery, useListAllIdeOrchestratorConfigOverridesQuery, useLazyListAllIdeOrchestratorConfigOverridesQuery, useListConfigChangeHistoryQuery, useLazyListConfigChangeHistoryQuery, useFleetCapacityMetricsQuery, useLazyFleetCapacityMetricsQuery, useReadSuperUserNamesQuery, useLazyReadSuperUserNamesQuery, useReadOrchestratorRunStatusQuery, useLazyReadOrchestratorRunStatusQuery, useReadUiSpeedSummaryQuery, useLazyReadUiSpeedSummaryQuery, useReadSreHubSummaryQuery, useLazyReadSreHubSummaryQuery, useReadSuperTenantFeatureFlagCatalogsQuery, useLazyReadSuperTenantFeatureFlagCatalogsQuery } = injectedRtkApi;

